import React from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import { homelabArticles } from "../../homelab/articles";
import { meta } from "../../content_option";

export const Article = () => {
  const { slug } = useParams();
  const article = homelabArticles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <Container className="article">
        <p className="section_label">
          <span className="idx">~/</span>
          <Link to="/portfolio" className="crumb">
            homelab
          </Link>
        </p>
        <h1 className="article__title">404 // not found</h1>
        <p>No writeup matches that path.</p>
        <Link className="article__back" to="/portfolio">
          ← back to projects
        </Link>
      </Container>
    );
  }

  return (
    <HelmetProvider>
      <Container className="article">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{article.title} | {meta.title}</title>
          <meta name="description" content={article.summary} />
        </Helmet>

        <p className="section_label">
          <span className="idx">~/</span>
          <Link to="/portfolio" className="crumb">
            homelab
          </Link>
          <span className="crumb-sep">/</span>
          {article.slug}
        </p>
        <h1 className="article__title">{article.title}</h1>

        <div className="article__meta mono">
          <span className="article__updated">updated: {article.updated}</span>
          <span className="article__tags">
            {article.tags.map((t) => (
              <span className="article__tag" key={t}>
                {t}
              </span>
            ))}
          </span>
        </div>

        <hr className="t_border" />

        <div className="article__body">{article.body}</div>

        <Link className="article__back" to="/portfolio">
          ← back to projects
        </Link>
      </Container>
    </HelmetProvider>
  );
};
